import 'core-js/es6/map';
import 'core-js/es6/weak-map';
import 'core-js/es6/set';
import 'es6-promise/auto';

import './Array.fill';
import './Array.find';
import './Array.findIndex';
import './Array.from';
import './Array.includes';
import './Object.assign';
import './Object.entries';
import './String.startsWith';
import './String.includes';



// WEBPACK FOOTER //
// ./src/utils/polyfills/index.js